import React, {
  FC
} from 'react';
import {
  useTranslation
} from 'react-i18next';

import {
  Spinner
} from 'src/shared/components';

import * as Style from './LoadingResults.style';

export const LoadingResults: FC = () => {
  const {
    t
  } = useTranslation();

  return (
    <Style.Container>
      <Style.SpinContainer>
        <Style.LoaderText>{`${t('common.Loading')}...`}</Style.LoaderText>

        <Spinner
          size={24}
          centered={false}
        />
      </Style.SpinContainer>

      <Style.Text>{t('calibration.verifyingAnswersForCalibration')}</Style.Text>
    </Style.Container>
  );
};
